/**
 * Read a local image file as a base64 data URL for API upload.
 * @param {File} file
 * @param {{ maxBytes?: number }} [options]
 * @returns {Promise<string>}
 */
export function readImageAsDataUrl(file, { maxBytes = 2 * 1024 * 1024 } = {}) {
  if (!file || !(file instanceof File)) {
    return Promise.reject(new Error("Choose an image file."));
  }
  if (!String(file.type || "").startsWith("image/")) {
    return Promise.reject(new Error("Logo must be an image (PNG, JPG, or WebP)."));
  }
  if (file.size > maxBytes) {
    return Promise.reject(new Error("Logo must be 2 MB or smaller."));
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = typeof reader.result === "string" ? reader.result : "";
      if (!result.startsWith("data:image/")) {
        reject(new Error("Could not read image."));
        return;
      }
      resolve(result);
    };
    reader.onerror = () => reject(new Error("Could not read image."));
    reader.readAsDataURL(file);
  });
}
